import { gqlRequest } from '@mdvip/shared/lib/graphql-client';
import { MyPaymentTransactionsDocument, type MyPaymentTransactionsQuery } from '@/graphql/generated/graphql';

export type PaymentTransactionPage = MyPaymentTransactionsQuery['myPaymentTransactions'];
export type PaymentTransaction = PaymentTransactionPage['edges'][number];

export interface PaymentTransactionsInput {
  offset: number;
  limit: number;
}

/**
 * One page of the member's payment history, newest first. `limit`/`offset` are always sent
 * explicitly rather than relying on the API's defaults (25 rows, offset 0).
 *
 * `types` is deliberately not sent, because the API defaults to `[PAYMENT]`, which is what the page's
 * disclaimer promises ("Refunds, transfers and payment reversals are not included").
 *
 * Unlike the payment-method mutations (creditCardApi.ts, bankAccountApi.ts), `myPaymentTransactions`
 * returns its Success type directly instead of a Success/Failure union, so there is no domain
 * failure code to map and no error class to throw. Callers handle infrastructure errors through
 * `extractGqlErrorCode`.
 */
export async function requestPaymentTransactions(input: PaymentTransactionsInput): Promise<PaymentTransactionPage> {
  const data = await gqlRequest(MyPaymentTransactionsDocument, { input });
  return data.myPaymentTransactions;
}
